<div class="card">

    <!-- HEADER -->
    <div class="card-header" (click)="openFromHeader()" title="Open children">
        <div class="card-icon">
            <span class="material-icons">report_problem</span>
        </div>
        <div class="card-title-section">
            <h3 class="card-title">{{ edit.titleDE || 'No title' }}</h3>
        </div>
        <span class="material-icons chevron-icon">chevron_right</span>
    </div>

    <!-- BODY -->
    <div class="card-body">

        <!-- Title DE -->
        <div class="info-row">
            <span class="material-icons info-icon">title</span>
            <div class="info-content">
                <span class="info-label">Title (DE)</span>
                <input pInputText [(ngModel)]="edit.titleDE" (input)="queueSave()" placeholder="Title (DE)" />
            </div>
        </div>

        <!-- Title EN -->
        <div class="info-row">
            <span class="material-icons info-icon">translate</span>
            <div class="info-content">
                <span class="info-label">Title (EN)</span>
                <input pInputText [(ngModel)]="edit.titleEN" (input)="queueSave()" placeholder="Title (EN)" />
            </div>
        </div>

        <!-- Category oder Severity -->
        <ng-container *ngIf="defect.hasChildren; else severityBlock">
            <div class="info-row">
                <span class="material-icons info-icon">account_tree</span>
                <div class="info-content">
                    <span class="info-label">Category</span>
                    <span class="info-value">{{ defect.childCount }} children</span>
                </div>
            </div>
        </ng-container>

        <ng-template #severityBlock>
            <div class="info-row">
                <span class="material-icons info-icon">warning</span>
                <div class="info-content">
                    <span class="info-label">Severity</span>
                    <div class="severity-buttons">
                        <button type="button" class="severity-btn" [class.active]="edit.critical"
                            (click)="edit.critical = !edit.critical; saveNow()">
                            Critical
                        </button>
                        <button type="button" class="severity-btn" [class.active]="edit.major"
                            (click)="edit.major = !edit.major; saveNow()">
                            Major
                        </button>
                        <button type="button" class="severity-btn" [class.active]="edit.minor"
                            (click)="edit.minor = !edit.minor; saveNow()">
                            Minor
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>

        <!-- Save State -->
        <div class="save-hint" *ngIf="saveState">
            <span *ngIf="saveState === 'saving'">Saving…</span>
            <span *ngIf="saveState === 'saved'" class="saved">Saved</span>
            <span *ngIf="saveState === 'error'" class="error">Error</span>
        </div>

    </div>
</div>
